import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// components
import UserAvatar from 'components/UserAvatar';

//antd components
import { Button } from 'antd';

// global user
import { withUser } from 'engine/Contexts/User.context';

function StudentInfo({
  view,
  dataStudent,
  onClick,
  showChangeButton,
  user,
  // default props
  className,
  style,
  ...rest
}) {
  const mainClassNames = classNames('student-info-wrapper', !showChangeButton && 'hide-actions', className);
  const { t } = useTranslation();

  const activeChild = dataStudent || user?.activeChild || null

  const onClickHandler = () => {
    !!onClick &&  onClick();
  }

  return (
    <div className={mainClassNames} onClick={onClick} style={style}>
      {activeChild?._id && view == 'full' && (
        <>
          <UserAvatar fontSize={22} width={60} height={60} user={activeChild} />
          <div className="student-info-wrapper__info">
            {activeChild?.description?.firstname &&
              activeChild?.description?.lastname && (
                <span className="info-name">
                  {activeChild?.description?.firstname}{' '}
                  {activeChild?.description?.lastname}
                </span>
              )}
            {activeChild?.school && (
              <span className="info-description">
                {activeChild?.school?.name}
              </span>
            )}
            {activeChild?.class_info?.title && (
              <span className="info-class">
                {activeChild?.class_info?.title}
              </span>
            )}
            {(!!showChangeButton) && (
              <Button className="info-btn" type="link" onClick={onClickHandler}>
                {t("students.changeStudent")}
              </Button>
            )}
          </div>
        </>
      )}
      {/* // compact view of student info (for header) */}
      {activeChild?._id && view == 'small' && (
        <>
          <div className="student-info-small-wrapper">
            <UserAvatar view='small' fontSize={16} width={41} height={41} user={activeChild} />
          </div>
        </>
      )}
    </div>
  );

}

StudentInfo.defaultProps = {
  showChangeButton: true,
  view: 'full'
};
StudentInfo.propTypes = {
  view: PropTypes.oneOf(['full', 'small']).isRequired,
  dataStudent: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
    PropTypes.string,
  ]),
  showChangeButton: PropTypes.oneOfType([
    PropTypes.bool,
  ]),
  onClick: PropTypes.func,
};

export default compose(
  memo,
  withUser
)(StudentInfo);
